import { APIAddress } from "constants/config";
import updateStudentState from "./updateStudentState";
//
// Archive student by student id
//
// example:
// unarchiveStudent(studentId)
// 			.then(()=>{
// 				// when success
// 			})
// 			.catch((err)=>{
// 				// when failed
// 			});
export default function unarchiveStudent(studentId) {

  if(!studentId){
    return new Promise((resolve, reject) => {
      reject({
        error: new Error('Missing school ID (number)')
      })
    })
  }

  return updateStudentState(studentId, "not_scheduled");
}



// WEBPACK FOOTER //
// ./src/controllers/controllers/student/unarchiveStudent.js